import React from 'react';
import wrap from 'wraptile';
import classNames from 'classnames';

import {TimelineMarker} from '../../TimelineTypes';

import './Diamond.scss';

export interface DiamondProps {
    marker: TimelineMarker;
    selected: boolean;
    onDiamondClicked: (marker: TimelineMarker) => void;
}

export const onDiamondClick = wrap((marker: TimelineMarker, onDiamondClicked: (marker: TimelineMarker) => void, event: MouseEvent) => {
    event.stopPropagation();
    
    onDiamondClicked(marker);
});

export default function Diamond(props: DiamondProps) {
    const {
        marker,
        selected,
        onDiamondClicked,
    } = props;
    
    const handleDiamondClick = onDiamondClick(marker, onDiamondClicked);
    
    return (
        <div
            role="button"
            aria-label="Ad Break marker"
            onClick={handleDiamondClick}
            className={classNames('diamond-container', {
                selected,
            })}
        >
            <div
                role="button"
                aria-label="Ad Break marker"
                onClick={handleDiamondClick}
                className={classNames('diamond', {
                    selected,
                })}
            />
            <div
                role="button"
                aria-label="Ad Break marker"
                onClick={handleDiamondClick}
                className={classNames('diamond-tail', {
                    selected,
                })}
            />
        </div>
    );
}
